export default "__VITE_ASSET__DgKJ$ikr__"